<template>
  <el-dialog
    title="订单详情"
    :visible.sync="visible"
    :before-close="handleClose"
    width="98%"
    top="30px"
  >
    <div class="dialog-body">
      <div class="module-control">
        <el-form
          ref="listQueryFormRef"
          inline
          :model="listQuery"
          label-width="80px"
          style="width: 100%"
        >
          <el-form-item label="款号" prop="styleNumberList">
            <el-select
              v-model="listQuery.styleNumberList"
              placeholder="请选择"
              style="width: 200px"
              size="small"
              multiple
              clearable
              filterable
              collapse-tags
            >
              <el-option
                v-for="item in styleOptions"
                :key="item.code"
                :label="item.code"
                :value="item.code"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="供应商" prop="supperCodeList">
            <el-select
              v-model="listQuery.supperCodeList"
              placeholder="请选择"
              style="width: 200px"
              size="small"
              multiple
              clearable
              filterable
              collapse-tags
            >
              <el-option
                v-for="(item, index) in supperOptions"
                :key="index"
                :label="item.code + '-' + item.value"
                :value="item.code"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="网点" prop="storeCodeList">
            <el-select
              v-model="listQuery.storeCodeList"
              placeholder="请选择"
              style="width: 200px"
              size="small"
              multiple
              clearable
              filterable
              collapse-tags
            >
              <el-option
                v-for="(item, index) in storeOptions"
                :key="index"
                :label="item.code + '-' + item.value"
                :value="item.code"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="分类" prop="productRemarkList">
            <el-select
              v-model="listQuery.productRemarkList"
              placeholder="请选择"
              style="width: 200px"
              size="small"
              multiple
              clearable
              filterable
              collapse-tags
            >
              <el-option
                v-for="item in productRemarkOptions"
                :key="item.code"
                :label="item.value"
                :value="item.code"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="订单状态" prop="orderStatus">
            <el-select
              v-model="listQuery.orderStatus"
              placeholder="请选择"
              style="width: 200px"
              size="small"
              clearable
              filterable
            >
              <el-option
                v-for="(key, value) in orderStatusOptions"
                :key="key"
                :label="key"
                :value="key"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="起止时间" prop="code">
            <el-date-picker
              v-model="listQuery.timeRange"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              size="small"
              :default-time="['00:00:00', '23:59:59']"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 360px"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item label="">
            <el-button
              type="primary"
              icon="Search"
              size="small"
              @click="onSearch"
            >
              查询
            </el-button>
            <el-button icon="Refresh" size="small" @click="onReset">
              重置
            </el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="module-table">
        <el-table
          :data="dataList"
          border
          max-height="600"
          :header-cell-style="{ backgroundColor: '#ec9368', color: '#000' }"
        >
          <el-table-column
            prop="orderNo"
            label="订单号"
            align="center"
            width="120"
          />
          <el-table-column
            prop="supperName"
            label="供应商名称"
            align="center"
            width="100"
          />
          <el-table-column
            prop="storeCode"
            label="网点编码"
            align="center"
            width="100"
          />
          <el-table-column
            prop="storeName"
            label="网点名称"
            align="center"
            width="160"
          />
          <el-table-column
            prop="storeType"
            label="网点类型"
            align="center"
            width="80"
          />
          <el-table-column
            prop="totalNumber"
            label="下单件数"
            align="center"
            width="80"
          />
          <el-table-column
            prop="totalWeight"
            label="总重量"
            align="center"
            width="80"
          />
          <el-table-column
            prop="totalTradePrice"
            label="合计批发价"
            align="center"
            width="100"
          />
          <el-table-column
            prop="createTime"
            label="下单时间"
            align="center"
            width="100"
          />

          <el-table-column
            prop="contactName"
            label="联系人姓名"
            align="center"
            width="100"
          />
          <el-table-column
            prop="contactPhone"
            label="联系人电话"
            align="center"
            width="120"
          />
          <el-table-column
            prop="contactAddress"
            label=" 联系人地址"
            align="center"
            width="220"
          />

          <el-table-column
            prop="pickType"
            label="取货方式"
            align="center"
            width="80"
          />
          <el-table-column
            prop="expressCode"
            label="快递编码"
            align="center"
            width="100"
          />
          <el-table-column
            prop="orderStatus"
            label="订单状态"
            align="center"
            width="80"
          />
          <el-table-column prop="remark" label="备注" align="left" />
        </el-table>
      </div>
      <div class="module-pagination">
        <el-pagination
          v-if="!!total"
          @size-change="
            (val) => {
              this.listQuery.size = val
              this.getList()
            }
          "
          @current-change="
            (val) => {
              this.listQuery.current = val
              this.getList()
            }
          "
          :current-page="listQuery.current"
          :page-sizes="[10, 20, 40, 60, 100]"
          :page-size="listQuery.size"
          layout="total, prev, pager, next, sizes, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import * as ApiAnalysis from '@/api/analysis'

export default {
  name: 'DialogOrder',
  props: {
    styleOptions: {
      type: Array,
      default: () => [],
    },
    supperOptions: {
      type: Array,
      default: () => [],
    },
    storeOptions: {
      type: Array,
      default: () => [],
    },
    productRemarkOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      visible: false,
      pageLoading: false,
      listQuery: {
        styleNumberList: [],
        supperCodeList: [],
        storeCodeList: [],
        productRemarkList: [],
        orderStatus: null,
        timeRange: [],
        startTime: null,
        endTime: null,
        current: 1,
        size: 100,
      },
      dataList: [],
      total: 0,
      orderStatusOptions: {
        waitPay: '待支付',
        accept: '已支付',
        production: '已送检',
        connected: '已入网',
        shippedOut: '已发货',
        success: '已完成',
        cancel: '已取消',
      },
    }
  },
  methods: {
    getList() {
      this.pageLoading = true
      ApiAnalysis.getOrderList({
        ...this.listQuery,
        startTime: this.listQuery.timeRange?.[0],
        endTime: this.listQuery.timeRange?.[1],
      })
        .then((res) => {
          this.dataList.splice(0, this.dataList.length)
          this.dataList.push(...res.data.records)
          this.total = res.data.total || 0
        })
        .finally(() => {
          this.pageLoading = false
        })
    },

    onSearch() {
      this.listQuery.current = 1
      this.getList()
    },

    onReset() {
      this.$refs.listQueryFormRef.resetFields()
      this.listQuery.current = 1
      this.listQuery.orderStatus = null
      this.listQuery.timeRange = []
      this.listQuery.startTime = null
      this.listQuery.endTime = null
      this.getList()
    },

    handleShow(data) {
      this.visible = true
      this.listQuery.styleNumberList = data?.styleNumberList || []
      this.listQuery.supperCodeList = data?.supperCodeList || []
      this.listQuery.storeCodeList = data?.storeCodeList || []
      this.listQuery.productRemarkList = data?.productRemarkList || []
      this.listQuery.timeRange = data?.timeRange || []
      this.listQuery.orderStatus = this.orderStatusOptions[data?.orderStatus]
      this.onSearch()
    },

    handleClose() {
      this.$refs.listQueryFormRef.resetFields()
      this.visible = false
    },
  },
}
</script>

<style scoped lang="scss">
.module-pagination {
  display: flex;
  justify-content: center;
  padding-top: 20px;
}
</style>
